import { MultiCombobox, styled } from '@project44/manifest-ds';

export const StyledMultiCombobox = styled(MultiCombobox, {
  '.manifest-multi-combobox__wrapper': {
    paddingRight: '$small',
  },
  '.manifest-multi-combobox__button': {
    display: 'none !important',
  },
  '.manifest-tag__text': {
    color: 'inherit',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '7rem',
  },
  '.manifest-multi-combobox__input': {
    padding: '0rem',
  },
  '.manifest-multicombobox_popover': {
    display: 'none !important',
    maxHeight: '0px',
  },
});
